export const formatTime = (time: number) => `${Math.floor(time / 60)}:${("0" + (time % 60)).slice(-2)}`;
